// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"__scrollbar__Ixq0a"};